let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cuOju")).then(() => parcelRequire('iyJtd'));